import clsx from "clsx"
import React, { FC } from "react"

import * as styles from "./BottomCta.module.scss"
import { PhoneImg, Sticker, GiftImage, BallsImg, FishImg, HalvaCardImg } from "./img"
import { BottomCtaProps } from "./types"
import { StickerBearImg } from "./img/StickerBearImg"

interface CtaImagesProps {
  variant: BottomCtaProps["variant"]
  StickerPay: boolean
  newYear: boolean
  AB: boolean
}

export const RightBlock: FC<CtaImagesProps> = ({ variant, StickerPay, newYear, AB }) => {
  if (variant === "stickerMode") {
    return (
      <>
        <StickerBearImg alt="sticker" className={clsx(styles.giftImg, styles[variant])} />
        <HalvaCardImg alt="halvaCard" className={clsx(styles.halvaCardImg, styles[variant])} />
      </>
    )
  }

  if (StickerPay) {
    return (
      <>
        <PhoneImg alt="phone" className={styles.phoneImg} />
        <Sticker alt="sticker" className={styles.stickerImg} />
      </>
    )
  }

  return (
    <>
      {!newYear ? (
        !AB && <GiftImage alt="gift" className={clsx(styles.giftImg, styles[variant])} />
      ) : (
        <BallsImg alt="gift" className={styles.ballsImg} />
      )}

      {AB && <FishImg alt="gift" className={clsx(styles.fishImg, styles[variant])} />}
      <HalvaCardImg alt="halvaCard" className={clsx(styles.halvaCardImg, styles[variant])} />
    </>
  )
}
